export const allPlanningApplicationTypes = ['listed', 'unlisted'] as const

export type PlanningApplicationType = (typeof allPlanningApplicationTypes)[number]
